/* Favoritos: conjunto montado (tipo Conjunto, sem SKU próprio) não vai direto para a sacola.
   Na página Meus favoritos, troca "Adicionar à sacola" por "Montar o conjunto" e tira o conjunto do "Colocar todos na sacola".
   (Caio, 22/10/2026, depois do pedido #011638.) */
(function () {
  'use strict';
  if (!/^\/pages\/favoritos/.test(location.pathname)) return;
  var estado = {};
  function ehKit(h) {
    if (!estado[h]) {
      estado[h] = fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return false;
          if (String(p.type || '').trim().toLowerCase() !== 'conjunto') return false;
          return p.variants.every(function (v) { return !v.sku; });
        })
        .catch(function () { return false; });
    }
    return estado[h];
  }
  function trocar(art) {
    var b = art.querySelector('[data-mt-favs-sacola]');
    if (!b) return;
    var a = document.createElement('a');
    a.className = 'mt-favs__btn';
    a.href = '/products/' + art.getAttribute('data-h');
    a.textContent = 'Montar o conjunto';
    b.parentNode.replaceChild(a, b);
  }
  function checar() {
    var arts = [].slice.call(document.querySelectorAll('.mt-favs__item[data-h]'));
    return Promise.all(arts.map(function (art) {
      var h = art.getAttribute('data-h');
      if (!h || !art.querySelector('[data-mt-favs-sacola]')) return null;
      return ehKit(h).then(function (k) { if (k) trocar(art); });
    }));
  }
  /* Clique em "Adicionar à sacola" ou "Colocar todos": confere os conjuntos antes de deixar seguir. */
  var liberado = false;
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest('[data-mt-favs-sacola],[data-mt-favs-tudo]');
    if (!alvo || liberado) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    checar().then(function () {
      if (!document.body.contains(alvo)) return;
      liberado = true;
      try { alvo.click(); } finally { liberado = false; }
    });
  }, true);
  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = true;
    setTimeout(function () { agendado = false; checar(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  checar();
})();
